import LabelIcon from "@material-ui/icons/Label";
import PlaceIcon from "@material-ui/icons/Place";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";

import { AppResource } from "../../../types/resource.types";
import { PlacesCreate, PlacesEdit, PlacesList } from "../../Places";
// import AgentProfile from "../../Profiles/AgentProfile";
import { VisitsRequestsList, VisitsRequestsShow } from "../../VisitsRequests";
import AgentDashboard from "./Dashboard";

export const agentAccount = {
  resources: [
    <Resource
      name={AppResource.places}
      list={PlacesList}
      edit={PlacesEdit}
      create={PlacesCreate}
      icon={PlaceIcon}
      options={{
        label: "Places",
      }}
    />,
    <Resource
      name={AppResource.visitsRequests}
      list={VisitsRequestsList}
      icon={LabelIcon}
      options={{
        label: "Visits requests",
      }}
    />,
    <Resource name={AppResource.clients} />,
  ],
  customRoutes: [
    <Route exact path={`/${AppResource.visitsRequests}/:visitRequestId`} component={VisitsRequestsShow} />,
    // <Route exact path={`/${AppResource.profile}`} component={AgentProfile} />,
  ],
  dashboard: AgentDashboard,
};
